/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DataAssetSearchParameters } from './DataAssetSearchParameters';
import type { StorageTier } from './StorageTier';

export type ChangeStorageTierParams = {
    search: DataAssetSearchParameters;
    target_tier: StorageTier;
    allow_early_deletion_fees?: boolean;
    rehydration_priority?: ChangeStorageTierParams.rehydration_priority;
};

export namespace ChangeStorageTierParams {

    export enum rehydration_priority {
        STANDARD = 'standard',
    }


}

